import { notLoggedIn } from '../../../routes/conditional';
import paths from '../../../routes/paths';
import { loginStart, clearLoginError, hideAppPromotion } from '../../../redux/modules/login';
import { setWardlesPharmacy, clearPharmacy } from '../../../redux/modules/auth';

export const page = {
  path: paths.login.root,
  isAllowed: [notLoggedIn],
  action: ({ query }) => {
    const isWardles = query && query._wardles === 'true'; // eslint-disable-line no-underscore-dangle
    if(isWardles) return setWardlesPharmacy();
    return clearPharmacy();
  },
};

export const startLogin = {
  actionPath: '/actions/login/access-start',
  emailField: 'email',
  action: ({ body }) => loginStart(body.email),
};

export const clearError = {
  actionPath: '/actions/login/clear-error',
  action: () => clearLoginError(),
};

export const clearAppPromotion = {
  actionPath: '/actions/login/clear-app-promotion',
  action: () => hideAppPromotion(),
};